// The project's global Long serializer returns numeric counters as strings.
// Normalize counters while keeping user IDs as strings to preserve their precision.
export function normalizeUsageReport(report) {
  const counterFields = [
    "loginCount",
    "requestCount",
    "sessionCount",
    "activeDays",
    "activeMillis",
    "receivedBytes",
    "sentBytes",
    "dataDownloadedBytes",
    "userCount",
    "activeUsers",
  ];
  const counters = (source) => {
    const result = { ...source };
    for (const field of counterFields) {
      if (field in result) result[field] = Number(result[field]) || 0;
    }
    return result;
  };
  return {
    ...report,
    total: Number(report.total) || 0,
    summary: counters(report.summary || {}),
    records: (report.records || []).map(counters),
  };
}

export function formatUsageDuration(millis) {
  const minutes = Math.floor(Math.max(0, Number(millis) || 0) / 60000);
  if (minutes === 0) return Number(millis) > 0 ? "不足1分钟" : "0分钟";
  const hours = Math.floor(minutes / 60);
  return hours ? `${hours}小时${minutes % 60}分钟` : `${minutes}分钟`;
}

export function formatUsageBytes(value) {
  const bytes = Math.max(0, Number(value) || 0);
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export function usageDateRange(days = 7) {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - days + 1);
  const format = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  return [format(start), format(end)];
}
